import { createResource } from "@/core";
import type { ILesson, ILessonCreate, ILessonUpdate } from "../types";

export const lessonResource = createResource<
  ILesson,
  ILessonCreate,
  ILessonUpdate
>({
  endpoint: "/lesson",
  queryKey: "lessons",
  staleTime: 10 * 60 * 1000,
});
